import { createContext, use } from 'react';
import type { FlagStore } from '../store/types';

export const FeatureFlagContext = createContext<FlagStore | null>(null);

export function useFeatureFlagStore(): FlagStore {
  const store = use(FeatureFlagContext);
  if (!store) {
    throw new Error('useFeatureFlagStore must be used within a <FeatureFlagProvider>');
  }
  return store;
}
